/**
 * Shared shell for every `/stores/[id]/rx/*` page.
 * Matches the CRM page rhythm: PageHeader + native sub-nav + content.
 */

import type { ReactNode } from 'react';

import { PageHeader } from '@/components/ui/page-header';
import { RxDocsButton } from './rx-docs-card';
import { RxNav } from './rx-nav';

export function RxPageShell({
  title,
  description,
  actions,
  children,
}: {
  title: string;
  description: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-col space-y-4 sm:space-y-6">
      <PageHeader title={title} description={description}>
        {actions}
        <RxDocsButton />
      </PageHeader>
      <RxNav />
      {children}
    </div>
  );
}
